import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const TEMAS_CONST = 'temas';
export const temasAcademicosApi = `${baseUrl}/temas-academicos`;

export const allTemasAcademicosService = async (params) => {
  const res = await axios.get(temasAcademicosApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveTemasAcademicosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${temasAcademicosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(temasAcademicosApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneTemasAcademicosService = async (id) => {
  const res = await axios.get(`${temasAcademicosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteTemasAcademicosService = async (id) => {
  const res = await axios.delete(`${temasAcademicosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const asignarTemaMateriasService = async (data) => {
  const res = await axios.post(`${baseUrl}/tema-materias`, data, {
    headers: token({}),
  });
  return res;
};

export const deleteTemaMateriasService = async (id) => {
  const res = await axios.delete(`${baseUrl}/tema-materias/${id}`, {
    headers: token({}),
  });
  return res;
};
